export default __webpack_public_path__ + "static/media/boom.3c9d3c4f.png";